import React, { createContext, useContext, useEffect, useState } from "react";
import { useUserStore } from "../stores/userStore";
import { useApiStore } from "../stores/apiStore";

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isInitialized, setIsInitialized] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const initializeAuth = useUserStore((state) => state.initializeAuth);
  const isAuthenticated = useUserStore((state) => state.isAuthenticated);
  const currentProject = useApiStore((state) => state.project);
  const isApiConfigured = useApiStore((state) => state.isConfigured);

  useEffect(() => {
    let isMounted = true;

    const initialize = async () => {
      try {
        setIsLoading(true);
        await initializeAuth();
        if (isMounted) {
          setIsInitialized(true);
        }
      } catch (error) {
        console.error("Auth initialization failed:", error);
        if (isMounted) {
          setIsInitialized(true);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    initialize();

    return () => {
      isMounted = false;
    };
  }, []); // Remove initializeAuth from dependencies to prevent re-execution

  const value = {
    isAuthenticated,
    isLoading: isLoading || !isInitialized,
    isInitialized,
    currentProject,
    isApiConfigured,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
